module.exports = require("@material-ui/core/Divider");